import { render, staticRenderFns } from "./commonRequest.vue?vue&type=template&id=3d728159&scoped=true&"
import script from "./commonRequest.vue?vue&type=script&lang=js&"
export * from "./commonRequest.vue?vue&type=script&lang=js&"
import style0 from "./commonRequest.vue?vue&type=style&index=0&id=3d728159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d728159",
  null
  
)

export default component.exports